<template>
    <el-dialog title="编辑账号信息" :visible="isShow" :before-close="handleClose">
        <el-form :model="model" ref="model" :rules="rules">
            <el-form-item label="用户名" prop="username" :label-width="formLabelWidth">
                <el-input v-model="model.username" :disabled="true" autocomplete="off"></el-input>
            </el-form-item>
<!--            <el-form-item label="登录密码" prop="password" :label-width="formLabelWidth">-->
<!--                <el-input type="password" v-model="model.password" :disabled="true" autocomplete="off"></el-input>-->
<!--                <p>温馨提示: 如果不需要修改密码请留空</p>-->
<!--            </el-form-item>-->
            <el-form-item label="真实姓名" prop="real_name" :label-width="formLabelWidth">
                <el-input v-model="model.real_name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="mobile" :label-width="formLabelWidth">
                <el-input v-model="model.mobile" autocomplete="off"></el-input>
                <p style="color: red">温馨提示: 更改手机号码请输入完整手机号，如果手机号包含 * 号则视为无效自动忽略</p>
            </el-form-item>
            <el-form-item v-if="groups.length > 0" label="所属组" prop="group_id" :label-width="formLabelWidth">
                <el-select v-model="model.group_id" style="width:100%" placeholder="请选择账号组">
                    <el-option
                            v-for="item in groups"
                            :key="item.id"
                            :label= "'[' + item.service_name + '] ' + item.name"
                            :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="身份" prop="identity" :label-width="formLabelWidth">
                <el-select v-model="model.identity" style="width:100%" placeholder="请选择账号组">
                    <el-option
                            v-for="(identity, key) in identities "
                            :key="key"
                            :label="identity"
                            :value="key"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="设为管理员" :label-width="formLabelWidth">
                <el-switch
                        v-model="model.is_admin"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-value="1"
                        inactive-value="0">
                </el-switch>
            </el-form-item>

            <el-form-item label="公有状态" :label-width="formLabelWidth">
                <el-switch
                        v-model="model.is_common"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        :active-value="1"
                        :inactive-value="0">
                </el-switch>
            </el-form-item>

            <el-form-item label="启用产品" :label-width="formLabelWidth" v-if="model.is_common">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                <el-checkbox-group v-model="model.product_ids" @change="handleCheckedProductChange">
                    <el-checkbox v-for="(product, index) in products" :label="product.id" :key="index">{{product.name}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>

           <!-- <el-form-item label="设为公用账号" :label-width="formLabelWidth">
                <el-switch
                        v-model="model.is_common"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-value="1"
                        inactive-value="0">
                </el-switch>
            </el-form-item>-->

            <!-- <el-form-item label="绑定科目" :label-width="formLabelWidth">
                <el-checkbox-group
                        v-model="subject_ids"
                        :min="1"
                        :max="13">
                    <el-checkbox v-for="subject in subjects" :label="subject.subject_id" :key="subject.subject_id">{{subject.subject_name}}</el-checkbox>
                </el-checkbox-group>
                <p style="color: red;">温馨提示: 绑定科目最多勾选13个科目</p>
            </el-form-item> -->

        </el-form>


        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button :loading="submiting" type="primary" @click="submitForm">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import AccountService from "~/services/CustomerAccounts";
    // import CommonService from "~/services/common";


    export default {
        name: "UpdateAccount",
        props: {
            account: {
                type: Object,
                default: null
            },
            display: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            display: function (value, origin) {
                this.isShow = value;
            }
        },
        data() {
            return {
                isShow: false,
                submiting: false,
                formLabelWidth: '120px',
                groups: [],
                model: null,
                identities: {},
                rules: {
                    customer_id: [
                        {required: true, message: "所属客户不允许为空", trigger: "blur"},
                    ],
                    password: [
                        {min: 6, max: 20, message: "密码长度最小6位最大不超过20位"}
                    ],
                    identity: [
                        {required: true, message: "必须选择一个身份", trigger: "blur"}
                    ],
                    real_name: [
                        {required: true, message: "真实姓名不允许为空", trigger: "blur"}
                    ]
                },
                subjects: [],
                subject_ids:[],

                products: [
                    {name: '二一校网通', id: 2},
                    // {name: '二一组卷', id: 1},
                    {name: '校本资源库', id: 5},
                ],
                checkAll: false,
                product_ids: [],
                isIndeterminate: false,
            }
        },
        created: function () {
            this.model = this.account;

            this.handleCheckedProductChange(this.model.product_ids);

            this.isShow = this.display;
        },

        methods: {

            close(status = false) {
                this.isShow = false;
                this.$refs["model"].resetFields();
                this.$emit("callback", status);
            },

            handleClose() {
                this.$confirm("陛下你还没有保存内容，确认要关闭窗口？", "温馨提示", {type: "warning"}).then(ok => {
                    this.close();
                }).catch(cancel => {
                    return false;
                });
            },

            getGroups(params) {
                AccountService.getGroups(params).then(res => {
                    if (res.code == 0 && res.data != null) {
                        this.groups = res.data;
                    }
                }).catch(err => {
                    console.error(err)
                })
            },

            submitForm() {
                this.$refs["model"].validate(valid => {
                    if (valid) {
                        this.submiting = true;
                        if(this.subject_ids.length > 13) {
                            this.$message.error('绑定科目最多勾选13个科目，请根据实际教授科目谨慎选择');
                            return false;
                        }
                        let params = _.clone(this.model);
                        params.subject_ids = this.subject_ids;

                        const ids = this.products.map(item => item.id);
                        const close_product_ids = ids.filter(id => !params.product_ids.includes(id));
                        params.product_ids = close_product_ids;

                        AccountService.updateAccount(params).then(res => {
                            this.submiting = false;
                            if (res.code == 0) {
                                this.$message({
                                    message: "更新成功!",
                                    type: "success",
                                    showClose: true,
                                });
                                this.close(true);
                            } else {
                                this.$message.error(res.msg);
                                return false;
                            }
                        }).catch(error => {
                            console.error(error);
                        })
                    }
                })
            },

            handleCheckAllChange(val) {
                const ids = this.products.map(item => item.id);
                this.model.product_ids = val ? ids : [];
                this.isIndeterminate = false;
            },

            handleCheckedProductChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount == this.products.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.products.length;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/customer/dialog/UpdateAccount.vue